import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TextService } from "../services/text.service";
import { AsyncPipe } from "@angular/common";
import {
  AlertComponent as TtAlertComponent,
  ButtonComponent as TtButtonComponent,
} from "@ticket-team-com/tt-component-library";

@Component({
  selector: "app-error",
  templateUrl: "./error.component.html",
  styleUrls: ["./error.component.css"],
  imports: [AsyncPipe, TtAlertComponent, TtButtonComponent],
})
export class ErrorComponent {
  public textService = inject(TextService);
  private router = inject(Router);

  retry(): void {
    this.router.navigate(["/payment"]);
  }
}
